import { useEffect } from "react";

/**
 * Attiva un IntersectionObserver globale per tutti gli elementi con classe
 * `.reveal`. Quando entrano nel viewport aggiunge `.in-view`, sfruttando la
 * transizione CSS già definita in index.css.
 *
 * Uso: chiamare `useRevealOnScroll()` una volta nel componente pagina
 * (Landing, Register, ecc.). Non richiede parametri.
 */
export default function useRevealOnScroll() {
  useEffect(() => {
    const els = Array.from(document.querySelectorAll(".reveal"));
    if (!els.length) return;

    // Fallback: se il browser non supporta IntersectionObserver, mostra tutto.
    if (typeof IntersectionObserver === "undefined") {
      els.forEach((el) => el.classList.add("in-view"));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );

    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
}
